'use client'

import { InputText } from '@vinted/web-ui'
import { FieldErrorsImpl } from 'react-hook-form'

import { useTranslate } from '@marketplace-web/shared/i18n'
import { renderValidation, useFormValidationMessage } from '@marketplace-web/shared/ui-helpers'

type Props = {
  isWide?: boolean
  isMasked?: boolean
  isDisabled?: boolean
  errors: FieldErrorsImpl<{
    [x: string]: any
  }>
  name: string
  value: string
  onChange: () => void
  onBlur: () => void
}

const PersonalIdNumberInput = ({
  isMasked,
  isDisabled,
  isWide,
  errors,
  name,
  value,
  onChange,
  onBlur,
}: Props) => {
  const translate = useTranslate('wallet.activation.general.fields')
  const validationMessage = useFormValidationMessage(
    errors,
    'wallet.activation.general.fields',
  )(name)

  const styling = isWide ? InputText.Styling.Wide : InputText.Styling.Narrow

  if (isMasked) {
    return (
      <InputText
        name={name}
        styling={styling}
        title={translate('personal_id_number.title')}
        placeholder={translate('personal_id_number.placeholder')}
        disabled={isDisabled}
        validation={renderValidation(validationMessage) || translate('personal_id_number.note')}
        value={'*'.repeat(11) ?? ''}
        onChange={() => undefined}
      />
    )
  }

  return (
    <InputText
      value={value ?? ''}
      name={name}
      styling={styling}
      title={translate('personal_id_number.title')}
      placeholder={translate('personal_id_number.placeholder')}
      disabled={isDisabled}
      validation={renderValidation(validationMessage) || translate('personal_id_number.note')}
      maxLength={11}
      onChange={onChange}
      onBlur={onBlur}
    />
  )
}

export default PersonalIdNumberInput
